module.exports = new __parcel__URL__("corrosivedecay.0ff4626b.png").toString();